<div id="account-search-input">
  <mat-form-field appearance="outline" class="mat-form-field-xs" subscriptSizing="dynamic">
    <button type="button" matPrefix mat-icon-button aria-label="Back" (click)="back()">
      <mat-icon>{{leftIcon}}</mat-icon>
    </button>
    <input type="text" matInput [formControl]="fc" [matAutocomplete]="autocomplete" placeholder="{{label}}"
      [readonly]="readonly" (focus)="onFocus()" (blur)="onBlur()">
      <button type="button" *ngIf="fc.value && !readonly" matSuffix mat-icon-button aria-label="Clear"
        (click)="valueClear()">
        <mat-icon>close</mat-icon>
      </button>
      <mat-autocomplete #autocomplete="matAutocomplete" [displayWith]="autocompleteDisplayWith"
        (optionSelected)="autocompleteOptionSelected.emit($event.option.value)">
        <mat-option *ngFor="let option of optionsFiltered | async" [value]="option">
          <img *ngIf="showAvatar" height="30" width="30" matListItemAvatar src="../../../assets/profile.jpg" alt="Avatar">
          <span> {{optionLabel(option)}}</span>
        </mat-option>
      </mat-autocomplete>
  </mat-form-field>
</div>
